import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import { getGeoServerKey } from '../../services/mapService';
import DefaultLoading from '../Loading';
import {default as DEMConfig} from './mapStatic/DEM'
import { getAreaOfInterest, getMapConfig } from '../../services/projectService';
import MillMapMenu from './millMapMenu';
import ForestMapMenu from './forestMapMenu';
import { getDefaultLinesCollection, getDefaultPolygonsCollection } from './utils';
import MeasureMapMenu from './measureMapMenu';
import { useDroneDetailContext } from '../Contexts/DroneDetailContext';
import { MenuWrapper } from './MapActionMenu';
import { getDefaultPointsCollection } from './utils';
import DeepLearning from './mapStatic/deepLearning';

const Wrapper = styled.div`
`;

const MapWrapper = styled.div`
  height: calc(100vh - 80px);
  min-height: 700px;
  position: relative;
  margin-bottom: 1.5rem;

  .ol-overlaycontainer-stopevent {
    position: absolute;
    width: 100% !important;
    height: 100% !important;
    margin: 0;
  }

  .ol-scale-line {
    position: absolute;
    right: 8px;
    bottom: 8px;

    .ol-scale-line-inner {
      position: absolute !important;
      bottom: 0 !important;
      right: 0 !important;
    }
  }

  .ol-mouse-position {
    position: absolute !important;
    top: 8px !important;
    right: 8px !important;
  }

  .cfm-geolocation {
    position: absolute !important;
    left: 8px !important;
    bottom: 68px !important;
    top: auto !important;
    /* transform: translateY(-50%) !important; */
    /* top: calc(50% + 14px) !important; */
  }

  .ol-zoom {
    position: absolute !important;
    left: 8px !important;
    bottom: 8px !important;
    top: auto !important;
    /* top: calc(50% + 1.5rem + 2.5rem) !important; */
    /* transform: translateY(-50%) !important; */
  }
`;

const Loading = styled(DefaultLoading)`
  margin: 60px auto;
  justify-content: center;
`;

// TODO
// - handle geoserverkey error
function  Map({ projectData, lineData, areaData, pointData, addFeature }) {
    const [isLoading, setLoading] = useState(true);
    const [isGenerated, setGenerated] = useState(false);
    const [geoserverKey, setGeoserverKey] = useState({});
    const [areaOfInterest, setAreaOfInterest] = useState(getDefaultLinesCollection(projectData.epsg));
    const [profiles, setProfiles] = useState(getDefaultLinesCollection(projectData.epsg));
    const [areas, setAreas] = useState(getDefaultPolygonsCollection(projectData.epsg));
    const [points, setPoints] = useState(getDefaultPointsCollection(projectData.epsg));
    const [error, setError] = useState(false);
    const [mapConfig, setMapConfig] = useState({})
    const { featuresData, setFeaturesData, setSelectedFeature, deletedFeature } = useDroneDetailContext();

    useEffect(() => {
        Promise.all([
        getAreaOfInterest(projectData.id, projectData.epsg)
          .then(data => {
            setAreaOfInterest(prev => ({
              ...prev,
              features: [
                {
                  type: 'Feature',
                  properties: {
                    name: null
                  },
                  geometry: data
                }
              ]
            }))
          }),
        getGeoServerKey()
          .then(data => {
              const key = btoa(`${data.user}:${data.password}`);
              setGeoserverKey(key);
          })
          .catch(() => {
              console.error('Cannot download geoserver key.')
          }),
          getMapConfig("map")
          .then(data =>{
            setMapConfig(data.config);
          })
        ])
        .catch(() => setError())
        .then(() => {
          setLoading(false);
        })
    }, []);

    useEffect(() => {
      console.log('source data - LINE', lineData);
      setProfiles(prev => ({
        ...prev,
        features: lineData,
      }));
    },[lineData]);


    useEffect(() => {
      console.log('source data - POINT', pointData);
      setPoints(prev => ({
        ...prev,
        features: pointData,
      }));
    },[pointData]);



    useEffect(()=> {
      if(isGenerated) {
        GIS.Layer.addFeatures('profile', profiles);
        profiles.features.forEach(f=>{
          if(f.properties.profile_type===0){
            GIS.Layer.setFeatureStyleByID('profile', 'profile', f.properties.id);
            }
            if(f.properties.profile_type===2){
                GIS.Layer.setFeatureStyleByID('profile', 'profileGround', f.properties.id);
            }
            if(f.properties.profile_type===3){
                GIS.Layer.setFeatureStyleByID('profile', 'profileAI', f.properties.id);
            }
            GIS.Layer.setFeatureAttributeByID('profile','label', `${f.properties.id} - ${f.properties.name}`, f.properties.id);
        })
      }
    },[isGenerated, profiles]);

    useEffect(()=> {
      if(isGenerated) {
        GIS.Layer.addFeatures('tree', points);
      }
    },[isGenerated, points]);

    useEffect(() => {
      console.log('source data - AREA', areaData);
      setAreas(prev => ({
        ...prev,
        features: areaData,
      }));
    },[areaData]);

    useEffect(()=> {
      if(isGenerated) {
        GIS.Layer.addFeatures('polygon', areas);
            areas.features.forEach(f=>{
                GIS.Layer.setFeatureStyleByID('polygon', 'areaPile', f.properties.id);
                GIS.Layer.setFeatureAttributeByID('polygon','label', `${f.properties.id}`, f.properties.id)
                GIS.Layer.setFeatureAttributeByID('polygon','label', `${f.properties.id} - ${f.properties.name}`, f.properties.id);
        })
      }
    },[isGenerated, areas]);

    useEffect(()=>{
      if(deletedFeature){
        setSelectedFeature(null)
        if(deletedFeature.geometry.type ==="Polygon"){
          GIS.Layer.removeFeatureByID('polygon', deletedFeature.properties.id, {attribute: 'id'});
          setFeaturesData(featuresData.filter(f=>f.properties.id !== deletedFeature.properties.id))
          return;
        }
        if(deletedFeature.geometry.type ==="Point"){
          GIS.Layer.removeFeatureByID('tree', deletedFeature.properties.id, {attribute: 'id'});
          setFeaturesData(featuresData.filter(f=>f.properties.id !== deletedFeature.properties.id))
          return;
        }
        GIS.Layer.removeFeatureByID('profile', deletedFeature.properties.id, {attribute: 'id'});
        setFeaturesData(featuresData.filter(f=>f.properties.id !== deletedFeature.properties.id))
        console.log("deleted", deletedFeature)
      }
    },[deletedFeature])

    useEffect(() => {
        window.addEventListener("keydown", (key)=>{
            if(key.key==='Escape'){
             return GIS.Edit.commit();
            }
        });
    })

  const addForestLabelLayers = ()=>{

    DeepLearning['authentication'] = geoserverKey;
    DeepLearning['name'] = `species`;
    DeepLearning.layers.push(`forest:deep_learning_${projectData.epsg}`);
    DeepLearning['epsg'] = projectData.epsg;
    DeepLearning['styles'] = "forest:species"
    DeepLearning['switcher']={
      title:"SPECIES",
      icon:"/assets/images/orthophoto.jpg"
    };
    console.log(DeepLearning)
    mapConfig.layer.push(DeepLearning);
    mapConfig.group.map(g => {
        if (g.name === 'rasters') {
            g.layers.push(`species`)
        }
    })
    const DeepLearningHealth =  structuredClone(DeepLearning);
    DeepLearningHealth['name'] = `health`;
    DeepLearningHealth['styles'] = "forest:health"
    DeepLearningHealth['switcher'] ={
      title:"HEALTH",
      icon:"/assets/images/orthophoto.jpg"
    };
    mapConfig.layer.push(DeepLearningHealth);
    mapConfig.group.map(g => {
        if (g.name === 'rasters') {
            g.layers.push(`health`)
        }
    })
  }

 const addLayersToMap =()=>{
  let layers=[]
  const DEMConfigCopy = structuredClone(DEMConfig);
  DEMConfigCopy['authentication'] = geoserverKey;
  DEMConfigCopy['name'] = `DEM`;
  DEMConfigCopy.layers.push(`dem_${projectData.id}`);
  DEMConfigCopy['epsg'] = projectData.epsg;
  mapConfig.layer.push(DEMConfigCopy);
  mapConfig.group.map(g => {
      if (g.name === 'rasters') {
          g.layers.push(`DEM`)
      }
  })

    console.log(projectData)
    projectData.composition.composition.forEach(c=>{
      console.log(c)
      layers.push(c);
          c['authentication'] = geoserverKey;
          c.layers.push(`ortho_${projectData.id}`);
          c['epsg'] = projectData.epsg;

          mapConfig.layer.push(c);
          mapConfig.group.map(g => {
              if (g.name === 'rasters') {
                  g.layers.push(c.name)
              }
          })
        })
    if(projectData.detected && projectData.device !=="RGB"){
    addForestLabelLayers();
    }
    return layers;
 }

    useEffect(() => {
        if (!isGenerated && !isLoading) {
            /* global GIS */
            GIS.Projection.init(mapConfig.projection);
            GIS.Style.init(mapConfig.style);
            const customLayers = addLayersToMap();
            GIS.Layer.init(mapConfig.layer, mapConfig.group);

            const demBandData = projectData.bendsStatistic.find(b=>b.band==="dem")
            const demEnvData =`min_dem:${demBandData.min};max_dem:${demBandData.max};`
            GIS.Layer.getLayer(`DEM`)
            .getSource()
            .updateParams({ ENV: demEnvData});

            customLayers.forEach(l=>{
            const redBandData = projectData.bendsStatistic.find(b=>b.band===l.bands[0].name)
            const greenBandData = projectData.bendsStatistic.find(b=>b.band===l.bands[1].name)
            const blueBandData = projectData.bendsStatistic.find(b=>b.band===l.bands[2].name)

            const envData = `min_red:${redBandData.min};max_red:${redBandData.max};min_green:${greenBandData.min};max_green:${greenBandData.max};min_blue:${blueBandData.min};max_blue:${blueBandData.max};red_index:${l.bands[0].index};green_index:${l.bands[1].index};blue_index:${l.bands[2].index};`
            GIS.Layer.getLayer(l.name)
            .getSource()
            .updateParams({ ENV: envData});
            })
            if(mapConfig.layer.find(l=>l.name === 'health' || l.name === 'species')){
            GIS.Layer.updateParams('health', {VIEWPARAMS: `id:${projectData.id}`})
            GIS.Layer.updateParams('species', {VIEWPARAMS: `id:${projectData.id}`})
            }
            GIS.Control.init(mapConfig.control);
            GIS.Interaction.init(mapConfig.map);
            GIS.Map.init(mapConfig.map, mapConfig.view);

            //Fix bad location
            GIS.Layer.addFeatures('AOI', areaOfInterest);
            try {
                const extent = GIS.Layer.getLayerExtent(`AOI`);
                GIS.Map.zoomToExtent(extent);
            } catch (e) {
                console.log("Ups. Cannot find the project location.")
            }

            setGenerated(true);
        }

        return function cleanup() {
            if (isGenerated) {
                GIS.Layer.clear();
                GIS.Interaction.clear();
                GIS.Control.clear();
                setGenerated(false);
            }
        };
    }, [isGenerated, isLoading]);

    return (
      <Wrapper>
        { isLoading && (
            <Loading message="Loading geoserver key..." />
        )}

        <MapWrapper>
          <div className="cfm-map" id="map">
            <MenuWrapper>
              <MeasureMapMenu GIS={GIS}/>
              {(isGenerated && projectData.location_type === 'mill') &&
                <MillMapMenu GIS={GIS} projectId={projectData.id} epsg={projectData.epsg} />}
              {(isGenerated && ["forest", "forestRGB", "forestMulti"].includes(projectData.location_type)) &&
                <ForestMapMenu GIS={GIS} addFeature={addFeature} epsg={projectData.epsg} />}
            </MenuWrapper>
          </div>
        </MapWrapper>
      </Wrapper>
    )
}

export default Map;